var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.208 46.2498H47.7913M26.208 55.4998H36.9997M58.583 6.1665H15.4163C14.5986 6.1665 13.8143 6.49135 13.2361 7.06959C12.6579 7.64783 12.333 8.43209 12.333 9.24984V64.7498C12.333 65.5676 12.6579 66.3519 13.2361 66.9301C13.8143 67.5083 14.5986 67.8332 15.4163 67.8332H58.583C59.4008 67.8332 60.185 67.5083 60.7633 66.9301C61.3415 66.3519 61.6663 65.5676 61.6663 64.7498V9.24984C61.6663 8.43209 61.3415 7.64783 60.7633 7.06959C60.185 6.49135 59.4008 6.1665 58.583 6.1665Z",
    stroke: "#5CA044",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.25 20.0415L33.9167 32.3748L27.75 26.2082",
    stroke: "#5CA044",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccess);
export default __webpack_public_path__ + "static/media/icon-success.6f551d3d457b97ec357835fedeffe91c.svg";
export { ForwardRef as ReactComponent };